import React, { useState } from "react";
import { Listbox as Base, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var capitalise = function capitalise(string) {
  if (string === void 0) {
    string = "";
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
};

export var Listbox = props => {
  var [value, setValue] = useState(props.default);

  var onChange = val => {
    setValue(val);
    props.onChange(val);
  };

  return /*#__PURE__*/_jsx(Base, {
    value: value,
    onChange: onChange,
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative mt-1",
      children: [/*#__PURE__*/_jsxs(Base.Button, {
        className: "relative w-48 pr-10 text-left pl-3 py-2 border border-grey-300/20 bg-white rounded-container cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-primary focus-visible:ring-offset-2 focus-visible:border-primary sm:text-sm",
        children: [/*#__PURE__*/_jsx("span", {
          className: "block truncate",
          children: capitalise(value == null ? void 0 : value.name) || props.placeholder || "Select one..."
        }), /*#__PURE__*/_jsx("span", {
          className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
          children: /*#__PURE__*/_jsx(SelectorIcon, {
            className: "w-5 h-5 text-gray-400",
            "aria-hidden": "true"
          })
        })]
      }), /*#__PURE__*/_jsx(Transition, {
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0 scale-95",
        enterTo: "transform opacity-100 scale-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100 scale-100",
        leaveTo: "transform opacity-0 scale-95",
        className: "absolute z-20 w-full",
        children: /*#__PURE__*/_jsx(Base.Options, {
          className: "w-full mt-1 overflow-auto text-base bg-white rounded-container shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
          children: props.values.map((value, i) => /*#__PURE__*/_jsx(Base.Option, {
            value: value,
            className: _ref => {
              var {
                active
              } = _ref;
              return "cursor-pointer select-none relative py-2 pl-10 pr-4 " + (active ? "text-foreground bg-neutral/10" : "text-foreground");
            },
            children: _ref2 => {
              var {
                selected
              } = _ref2;
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "block truncate " + (selected ? "font-bold" : "font-normal"),
                  children: capitalise(value.name)
                }), selected ? /*#__PURE__*/_jsx("span", {
                  className: "absolute inset-y-0 left-0 flex items-center pl-3",
                  children: /*#__PURE__*/_jsx(CheckIcon, {
                    className: "w-5 h-5",
                    "aria-hidden": "true"
                  })
                }) : null]
              });
            }
          }, i))
        })
      })]
    })
  });
};
//# sourceMappingURL=listbox.js.map